module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/icon_save-9bf928fa4687789e10f9cebaaf970cf8.png";